<div class="dialogMain">
  <p mat-dialog-title class="dialogTitle">DELETING DEVICES</p>
  @if (data.isFlashing) {
    <div mat-dialog-content>
      <p class="dialogText">Data will be lost. This action cannot be undone.</p>
      <p class="dialogText">Do you want to continue ?</p>
    </div>
  }
  @if (!data.isFlashing) {
    <div mat-dialog-content>
      <img src="assets/warning.png" />
      <p class="dialogTextError">Message du capteur non reçu.</p>
      <!--<p class="dialogTextError">Please, insure those identified captors have been put aside.</p>-->
      <p class="dialogTextError">Are you sure you want to go back ?</p>
    </div>
  }
  <div>
    <button mat-button [mat-dialog-close]="false" class="dialogLogoutBtnNo">
      <mat-icon class="dialogIconNo">close</mat-icon> NO
    </button>
    <button mat-button [mat-dialog-close]="true" class="dialogLogoutBtnYes">
      YES <mat-icon class="dialogIconYes">check</mat-icon>
    </button>
  </div>
</div>
